import React, { useState, useEffect } from "react";

const Timer = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <div className="timer">
      {minutes > 0 && `${minutes} minute${minutes > 1 ? "s" : ""} `}
      {`${remainingSeconds} second${remainingSeconds !== 1 ? "s" : ""}`}
    </div>
  );
};

export default Timer;
